/**
 * 動画のKVロード完了時の共通処理
 * @param {boolean} isPc KVはPCか
 */
const loadedMovieKeyVisual = (isPc) => {
  const movieClass = isPc ? `.top-movie_pc` : `.top-movie_sp`

  /**
   * DOMContentLoaded時の処理
   */
  const handleDOMContentLoaded = () => {
    const videoElement = document.querySelector(`${movieClass} .top-key-visual-images-area video`)

    /**
     * ロード完了イベント
     *
     * 通信状況によって、loadedmetadataが発火しない可能性もあるので、複数のイベントを扱う
     */
    const loadedTriggerEvents = [`loadedmetadata`, `canplay`, `playing`, `loadeddata`]
    let done = { pc: false, sp: false }

    const handleLoaded = (event) => {
      // 複数イベントが実行される可能性があるのでPC、SPそれぞれで一度のみ処理を行う
      if ((isPc && done.pc) || (!isPc && done.sp)) return

      videoElement.classList.add('loaded')
      videoElement.removeEventListener(event.type, handleLoaded)
      if (isPc) {
        done.pc = true
      } else {
        done.sp = true
      }
    }

    if (videoElement) {
      loadedTriggerEvents.forEach((eventType) => {
        videoElement.addEventListener(eventType, handleLoaded)
      })
    }
  }

  // JS読み込み時にDOMContentLoadedが発火済みの場合もあるため、直接実行することも考慮
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleDOMContentLoaded)
  } else {
    handleDOMContentLoaded()
  }
}

export { loadedMovieKeyVisual }
